import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

function Pagination({
  currentPage,
  totalPages,
  hasNextPage,
  hasPreviousPage,
  onGoToPage,
  onGoToNext,
  onGoToPrevious,
  onGoToFirst,
  onGoToLast,
  startIndex,
  endIndex,
  totalItems,
}) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="mt-6 flex flex-col gap-4 rounded-xl border border-app-border/70 bg-app-surface/90 p-4 shadow-subtle md:flex-row md:items-center md:justify-between">
      <div className="text-sm font-medium text-app-muted">
        Showing {startIndex} to {endIndex} of {totalItems} items
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <button
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-app-border bg-app-surface text-app-muted transition hover:bg-app-surface-alt hover:text-app-ink disabled:cursor-not-allowed disabled:opacity-45"
          onClick={onGoToFirst}
          disabled={!hasPreviousPage}
          aria-label="Go to first page"
          title="First page"
          type="button"
        >
          <ChevronsLeft className="h-4 w-4" aria-hidden="true" />
        </button>

        <button
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-app-border bg-app-surface text-app-muted transition hover:bg-app-surface-alt hover:text-app-ink disabled:cursor-not-allowed disabled:opacity-45"
          onClick={onGoToPrevious}
          disabled={!hasPreviousPage}
          aria-label="Previous page"
          title="Previous page"
          type="button"
        >
          <ChevronLeft className="h-4 w-4" aria-hidden="true" />
        </button>

        <label className="flex items-center gap-2 rounded-lg border border-app-border bg-app-surface px-3 py-2 text-sm font-medium text-app-muted">
          <span>Page</span>
          <input
            type="number"
            min="1"
            max={totalPages}
            value={currentPage}
            onChange={(event) => {
              const pageNum = parseInt(event.target.value, 10);
              if (!Number.isNaN(pageNum)) {
                onGoToPage(pageNum);
              }
            }}
            className="w-14 rounded-md border border-app-border bg-app-surface-alt px-2 py-1 text-center font-semibold text-app-ink outline-none focus:ring-2 focus:ring-app-accent/30"
            aria-label="Current page"
          />
          <span>of {totalPages}</span>
        </label>

        <button
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-app-border bg-app-surface text-app-muted transition hover:bg-app-surface-alt hover:text-app-ink disabled:cursor-not-allowed disabled:opacity-45"
          onClick={onGoToNext}
          disabled={!hasNextPage}
          aria-label="Next page"
          title="Next page"
          type="button"
        >
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
        </button>

        <button
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-app-border bg-app-surface text-app-muted transition hover:bg-app-surface-alt hover:text-app-ink disabled:cursor-not-allowed disabled:opacity-45"
          onClick={onGoToLast}
          disabled={!hasNextPage}
          aria-label="Go to last page"
          title="Last page"
          type="button"
        >
          <ChevronsRight className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
